import React from 'react';
import { Provider } from 'react-redux';
import ReactOnRails from 'react-on-rails';
import PropTypes from 'prop-types';
import MainLayout from '../../containers/MainLayout/MainLayout';
import MainSearch from '../../containers/MainSearch/MainSearch';
import AboutUsLeftPart from '../../containers/AboutUsPage/AboutUsLeftPart';
import AboutUsRightPart from '../../containers/AboutUsPage/AboutUsRightPart/AboutUsRightPart';

const AboutUsPage = (props) => {
  const appStore = ReactOnRails.getStore('appStore');
  const { footerData, quotePath } = props;


  return (
    <div>
      <Provider store={appStore}>
        <MainLayout footerData={footerData}>
          <div className="grey-background">
            <div className="container">
              <div className="row">
                <AboutUsLeftPart quotePath={quotePath} />
                <AboutUsRightPart />
              </div>
              <MainSearch />
            </div>
          </div>
        </MainLayout>
      </Provider>
    </div>
  );
};


AboutUsPage.propTypes = {
  footerData: PropTypes.oneOfType([PropTypes.object]),
  quotePath: PropTypes.string,
};

AboutUsPage.defaultProps = {
  footerData: {},
  quotePath: '',
};

export default AboutUsPage;
